import { createFileRoute, redirect } from "@tanstack/react-router";

// Duplicate of /privacy; send visitors and crawlers to the canonical page.
export const Route = createFileRoute("/privacy-policy")({
  beforeLoad: () => {
    throw redirect({ to: "/privacy", statusCode: 301 });
  },
});
